import PageHeader from "components/PageHeader";
import useTabParam from "components/hooks/useTabParam";
import DSBox from "views/system-design/DSBox";
import DSSegmentedTabs from "views/system-design/DSSegmentedTabs";
import GlobalConfigTab from "./GlobalConfigTab";
import OverridesTab from "./OverridesTab";

const TABS = ["global", "overrides"] as const;

/**
 * Values the fleet reads without an app release: one global document, plus a per-clock
 * override for the cases that need to differ.
 */
const ClockConfiguration = () => {
  const [tabParam, setTabParam] = useTabParam("tab", "global", TABS);

  return (
    <DSBox>
      <PageHeader
        overline="Devices"
        title="Clock Configuration"
        subtitle="Tune fleet values without shipping an app version — clocks fetch daily at 04:xx, or immediately on the Refresh Config command"
        tabs={
          <DSSegmentedTabs
            options={[
              { label: "Global", value: "global" },
              { label: "Per-clock overrides", value: "overrides" },
            ]}
            value={tabParam ?? "global"}
            onChange={(value) => setTabParam(value)}
          />
        }
      />
      {tabParam === "global" && <GlobalConfigTab />}
      {tabParam === "overrides" && <OverridesTab />}
    </DSBox>
  );
};

export default ClockConfiguration;
